import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../AppContext.jsx";
import useWorks from "../../hooks/useWorks.js";
import useUsers from "../../hooks/useUsers.js";
import { langComponent, PAGE_STATE } from "../../constants/index.jsx";
import ProfileContext from "./ProfileContext.jsx";
import { useLocation } from "react-router-dom";
import ContentLoader from "react-content-loader";
import List, { STATE } from "../List/index.jsx";
import SecondaryPagination from "../SecondaryPagination/SecondaryPagination.jsx";
import { Button, Overlay } from "../index.js";
import { format } from "date-fns";
import Switch from "react-switch";
import { startOfDay } from "date-fns";
import { ReactComponent as WarningSvg } from "../../assets/icons/warning.svg";
import { ReactComponent as LinkSvg } from "../../assets/icons/link.svg";
import { ReactComponent as ArrowDownSvg } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as DownloadSvg } from "../../assets/profile/download.svg";
import { ReactComponent as StarSvg } from "../../assets/profile/star.svg";
import { ReactComponent as ViewSvg } from "../../assets/profile/views.svg";
import { ReactComponent as EditSvg } from "../../assets/profile/edit.svg";
import { ReactComponent as ShareSvg } from "../../assets/profile/share.svg";
import { ReactComponent as DeleteSvg } from "../../assets/profile/delete.svg";
import { toast } from "react-toastify";
import TextBox from "../common/TextBox/index.jsx";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import useLandingPage from "../../hooks/useLandingPage.js";
import * as Tooltip from "react-tooltip";
import _ from "lodash";
import ShareProject from "./ShareProject.jsx";
const assetsURI = import.meta.env.ASSETS_URI;

const ProjectOwner = () => {
  const { viewProject, getLang, designStyles } = useContext(AppContext);
  const Translation = getLang(langComponent.onboard);
  const TranslationCommon = getLang(langComponent.common);
  const { queryWorks, deleteWork, patchWork } = useWorks();
  const { queryLandingPageConfigs } = useLandingPage();
  const { queryUsers } = useUsers();
  const [projects, setProjects] = useState(undefined);
  const [dataState, setDataState] = useState(STATE.LOADING);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [metadata, setMetadata] = useState(undefined);
  const { user, company, isCompany } = useContext(ProfileContext);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(undefined);
  const [selectedType, setSelectedType] = useState(undefined);
  const [sort, setSort] = useState({ createdOn: -1 });
  const [sortText, setSortText] = useState("Latest");
  const [toggleDelete, setToggleDelete] = useState(undefined);
  const [toggleCopy, setToggleCopy] = useState(false);
  const [copy, setCopy] = useState(undefined);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const prefix = "profile-project-owner";

  const sortList = [
    { name: "Lowest price to high", value: { price: 1 } },
    { name: "Highest price to low", value: { price: -1 } },
    {
      name: "Oldest",
      value: { createdOn: 1 },
    },
    { name: "Latest", value: { createdOn: -1 } },
  ];

  const Types = {
    1: "Panorama",
    2: "Work Exchange",
    3: "Images",
  };

  const handleMouseEnter = () => {
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };
  const handleChangeSort = ({ name, value }) => {
    setSort(value);
    setSortText(name);
    setIsDropdownOpen(false);
  };

  const columns = [
    {
      display: "Project",
      key: "banner",
      textAlign: "left",
      width: "430px",
    },
    {
      display: "Collaborators",
      key: "collaborators",
      textAlign: "left",
    },
    {
      display: "Type",
      key: "type",
      textAlign: "left",
    },
    {
      display: "",
      key: "status",
      textAlign: "left",
    },
  ];

  useEffect(() => {
    setPageState(PAGE_STATE.LOADING);

    if (!designStyles) return;
    if ((isCompany && !company) || (!isCompany && !user)) return;

    fetchData();
    return () => {};
  }, [user, company, isCompany, sort, designStyles, limit, page]);

  const fetchPromote = async (workList) => {
    const promotes = await queryLandingPageConfigs(
      {
        work: {
          $in: workList,
        },
        effectiveDate: {
          $gte: startOfDay(new Date()),
        },
        active: true,
        deleted: false,
      },
      page,
      limit,
      {},
      {
        _id: 1,
        work: 1,
        effectiveDate: 1,
        dueDate: 1,
        price: 1,
      }
    );
    return promotes?.data;
  };

  const fetchData = async () => {
    setDataState(PAGE_STATE.LOADING);
    const filter = {
      deleted: false,
    };

    if (isCompany) {
      filter.company = company._id;
    }

    if (!isCompany) {
      filter.createdBy = user._id;
      filter.company = null;
    }

    const _works = await queryWorks(
      filter,
      page,
      limit,
      {
        name: 1,
        banner: 1,
        type: 1,
        desc: 1,
        active: 1,
        createdOn: 1,
        designType: 1,
        createdBy: 1,
        views: 1,
        downloads: 1,
        updatedBy: 1,
        updatedOn: 1,
      },
      sort
    );

    let worksToDisplay = _.cloneDeep(_works?.data);

    if (isCompany) {
      const _usersToFetch = [];

      for (const _work of _works.data) {
        if (_work.createdBy) {
          _usersToFetch.push(_work.createdBy);
        }

        if (_work.updatedBy) {
          _usersToFetch.push(_work.updatedBy);
        }
      }

      // * Get users if is a company project
      const { data: _users } = await queryUsers(
        {
          _id: {
            $in: _usersToFetch,
          },
        },
        1,
        _usersToFetch.length,
        {
          avatar: 1,
          firstname: 1,
          surname: 1,
        }
      );

      worksToDisplay = worksToDisplay?.map((w) => {
        if (w.createdBy) {
          w.createdBy = _users.find((u) => u._id === w.createdBy);
        }

        if (w.updatedBy) {
          w.updatedBy = _users.find((u) => u._id === w.updatedBy);
        }

        return w;
      });
    }

    const data = _mapData(worksToDisplay);

    setProjects(data);
    setMetadata(_works?._metadata);
    setPageState(PAGE_STATE.IDLE);
    setDataState(PAGE_STATE.IDLE);
  };

  const _mapData = (data, promotes = []) => {
    return data.map(
      (
        {
          _id,
          name,
          banner,
          type,
          active,
          createdOn,
          updatedOn,
          downloads,
          likes,
          designType,
          createdBy,
          updatedBy,
        },
        index
      ) => {
        const _createdOn = createdOn
          ? format(new Date(createdOn), "dd/MM/yyyy")
          : "-";

        const _updatedOn = updatedOn
          ? format(new Date(updatedOn), "dd/MM/yyyy")
          : "-";

        const _downloads = downloads ? downloads : 0;
        const _likes = likes ?? 0;

        return {
          _id,
          _type: type,
          name,
          no: index,
          joined: _createdOn,
          banner: (
            <div className={`${prefix}-lists-item-name`}>
              <div className={`${prefix}-lists-item-name-banner`}>
                <img
                  className={`${prefix}-lists-item-name-banner__image`}
                  src={`${assetsURI}/${banner}`}
                />
              </div>
              <div className={`${prefix}-lists-item-name-desc`}>
                <div className={`${prefix}-lists-item-name-desc__name`}>
                  {name}
                </div>
                <div className={`${prefix}-lists-item-name-desc-statistics`}>
                  <div
                    className={`${prefix}-lists-item-name-desc-statistics-item`}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={`Ratings`}
                  >
                    <StarSvg
                      className={`${prefix}-lists-item-name-desc-statistics-item__icon`}
                      height={18}
                    />
                    <span
                      className={`${prefix}-lists-item-name-desc-statistics-item__value`}
                    >
                      {_likes}
                    </span>
                  </div>
                  <div
                    className={`${prefix}-lists-item-name-desc-statistics-item`}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={`Views`}
                  >
                    <ViewSvg
                      className={`${prefix}-lists-item-name-desc-statistics-item__icon`}
                      height={22}
                    />
                    <span
                      className={`${prefix}-lists-item-name-desc-statistics-item__value`}
                    >
                      {_downloads}
                    </span>
                  </div>
                  <div
                    className={`${prefix}-lists-item-name-desc-statistics-item`}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={`Sold`}
                  >
                    <DownloadSvg
                      className={`${prefix}-lists-item-name-desc-statistics-item__icon`}
                      height={20}
                    />
                    <span
                      className={`${prefix}-lists-item-name-desc-statistics-item__value`}
                    >
                      {_downloads}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ),
          type: (
            <div className={`${prefix}-lists-type`}>
              <div
                className={`${prefix}-lists-type__chip ${prefix}-lists-type__chip--${type}`}
              >
                {Types[type]}
              </div>
            </div>
          ),
          collaborators: (
            <div className={`${prefix}-lists-collaborators`}>
              {createdBy && (
                <img
                  className={`${prefix}-lists-collaborators-user`}
                  alt="logo"
                  src={`${assetsURI}/${createdBy.avatar}`}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={`${createdBy.firstname} created on ${_createdOn}`}
                  onError={({ target }) => {
                    target.src = createdBy.avatar;
                  }}
                />
              )}
              {updatedBy && createdBy._id !== updatedBy._id && (
                <img
                  className={`${prefix}-lists-collaborators-user`}
                  alt="logo"
                  src={updatedBy.avatar}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={`${updatedBy.firstname} updated on ${_updatedOn}`}
                />
              )}
            </div>
          ),
          status: (
            <div className={`${prefix}-lists-actions`}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Switch
                  checked={active}
                  onChange={(value) => {
                    handleChangeStatus(_id, value);
                  }}
                  onColor="#013565"
                  onHandleColor="#FFF"
                  handleDiameter={15}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={24}
                  width={38}
                  className="react-switch"
                  id={`blog-switch-${_id}`}
                />
              </div>
              <EditSvg
                className={`${prefix}-lists-actions-action`}
                width={24}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit({ _id, type, designType });
                }}
              />
              <ShareSvg
                className={`${prefix}-lists-actions-action`}
                width={24}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyLinkClick(_id, type);
                }}
              />
              <DeleteSvg
                className={`${prefix}-lists-actions-action ${
                  _downloads > 0
                    ? `${prefix}-lists-actions-action--disable`
                    : ""
                }`}
                width={24}
                onClick={(e) => {
                  e.stopPropagation();
                  if (_downloads <= 0) handleToggleDelete(_id);
                }}
              />
            </div>
          ),
        };
      }
    );
  };

  const handleChangeStatus = async (id, value) => {
    try {
      await patchWork(id, { active: value });
      toast.success(`${value ? "Activated" : "Deactived"} successfully!`);

      // * Update display
      fetchData();
    } catch (error) {
      console.error(error.message);
      toast.error("Unable to Update Work");

      setDataState(PAGE_STATE.ERROR);
    }
  };

  const handleToggleDelete = (id) => {
    setToggleDelete(true);
    setSelected(id);
  };

  const handleEdit = ({ _id, type, designType }) => {
    setSelected(_id);
    navigate(`/new-project?edit=${_id}`);
    return;
  };

  const handleCopyLinkClick = (id, type) => {
    let typePath = type === 1 ? "projects" : "work-exchanges";
    const link = `${window.location.origin}/${typePath}/${id}`;
    setCopy(link);
    setSelectedType(type);
    setSelected(id);
    setToggleCopy(!toggleCopy);
  };

  const handleOnPageChange = (page) => {
    setPage(page);
  };

  const handleOnLimitChange = (limit) => {
    setLimit(limit);
  };

  const handleWorkClick = ({ _id, type }) => {
    if (type === 2) {
      const link = `/work-exchanges/${_id}`;
      navigate(link);
      return;
    }

    viewProject(_id, location);
  };

  const handleViewClose = () => {
    setSelected(undefined);
    setToggleDelete(false);
    setToggleCopy(false);
  };

  const handleDelete = async (id) => {
    try {
      // * Get work from datasource
      const _work = projects.find((project) => project._id === id);

      if (!_work) return;

      await deleteWork(id);
      setToggleDelete(false);
      setSelected(undefined);
      await fetchData();
      toast.success(`Deleted ${_work.name}`);

      setDataState(PAGE_STATE.IDLE);
    } catch (error) {
      console.error(error.message);
      toast.error(`Unable to delete ${_work.name}`);

      setDataState(PAGE_STATE.ERROR);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(copy);

    toast.info("Copied work link to clipboard", {
      autoClose: 2000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    });
  };

  const loadingComponent = () => {
    return (
      <ContentLoader
        width={800}
        height={100}
        viewBox="0 0 800 100"
        backgroundColor="#6f6d6d"
        foregroundColor="#7f7a7a"
      >
        <rect x="7" y="15" rx="10" ry="10" width="84" height="87" />
        <rect x="119" y="47" rx="0" ry="0" width="84" height="13" />
        <rect x="300" y="47" rx="0" ry="0" width="84" height="13" />
        <rect x="500" y="47" rx="0" ry="0" width="84" height="13" />
        <rect x="700" y="47" rx="0" ry="0" width="84" height="13" />
        <rect x="700" y="66" rx="0" ry="0" width="84" height="10" />
      </ContentLoader>
    );
  };

  const _getModalDelete = () => {
    // * Get work from datasource
    const _work = projects.find((project) => project._id === selected);

    return (
      <>
        <Overlay
          onClose={() => {
            handleViewClose();
          }}
          style={{
            alignItems: "flex-start",
          }}
        >
          <div className={`${prefix}-delete`}>
            <WarningSvg width={64} />
            <p className={`${prefix}-delete__header`}>
              {TranslationCommon(`Delete ${_work.name}?`)}
            </p>
            <div className={`${prefix}-delete__action`}>
              <Button
                variant={"secondary"}
                label={"Cancel"}
                onClick={handleViewClose}
              />
              <Button
                label={"Confirm"}
                onClick={() => handleDelete(selected)}
              />
            </div>
          </div>
        </Overlay>
      </>
    );
  };

  const _getModalCopy = () => {
    return (
      <>
        <Overlay
          onClose={() => {
            handleViewClose();
          }}
          style={{
            alignItems: "flex-start",
          }}
        >
          <div className={`${prefix}-copy`}>
            <p
              className={`${prefix}-copy__header`}
              style={{ marginBottom: 24 }}
            >
              {TranslationCommon("Copy Link")}
            </p>
            <Formik initialValues={{ copy }}>
              <Form>
                <TextBox
                  name={"copy"}
                  trailingIcon={<LinkSvg />}
                  disabled
                ></TextBox>
              </Form>
            </Formik>

            <div className={`${prefix}-copy__action`}>
              <Button
                variant={"secondary"}
                label={"Cancel"}
                onClick={handleViewClose}
              />
              <Button label={"Copy"} onClick={() => handleCopyLink(selected)} />
            </div>
          </div>
        </Overlay>
      </>
    );
  };

  if (pageState !== PAGE_STATE.IDLE) {
    const result = [];
    for (let i = 1; i <= limit; i++) {
      result.push(loadingComponent());
    }
    return <div className={`${prefix}__loader`}>{result}</div>;
  }

  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header__chip`}></div>
        <div
          className={`${prefix}-header-dropdown`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {`Sort By: ${sortText}`}
          <ArrowDownSvg />
          {isDropdownOpen && (
            <div className={`${prefix}-header-dropdown__menu`}>
              {sortList.map((item) => {
                return (
                  <div onClick={() => handleChangeSort(item)}>{item.name}</div>
                );
              })}
            </div>
          )}
        </div>
        {/* <div className={`${prefix}-header__filter`}>
          <FilterSvg />
        </div> */}
      </div>
      <List
        className={`${prefix}-lists-item`}
        contentState={dataState}
        columns={
          isCompany ? columns : columns.filter((c) => c.key !== "collaborators")
        }
        dataSource={projects}
        viewable={true}
        onRecordClick={(e) => {
          handleWorkClick({ _id: e._id, type: e._type });
        }}
      >
        <SecondaryPagination
          limits={[10, 50]}
          defaultPage={page}
          defaultLimit={limit}
          pages={metadata?.totalPages ?? 1}
          onPageChange={handleOnPageChange}
          onLimitChange={handleOnLimitChange}
        />
      </List>
      {toggleDelete && _getModalDelete()}
      {toggleCopy && <ShareProject link={copy} onClose={handleViewClose} />}
      <Tooltip.Tooltip id="my-tooltip" />
    </div>
  );
};

ProjectOwner.propTypes = {};

ProjectOwner.defaultProps = {};

export default ProjectOwner;
